// Hook akceptacji oferty przez klienta - PUT /sales-crm/my-offers/:id/accept

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface ISalesCrmMyOfferSelectedVariant {
  positionId: number;
  qtyFrom: number;
}

export interface IPutSalesCrmMyOfferAcceptPayload {
  selectedVariants?: ISalesCrmMyOfferSelectedVariant[];
}

const putSalesCrmMyOfferAccept = (
  offerId: string | number,
  payload?: IPutSalesCrmMyOfferAcceptPayload
): Promise<ICommandResponseSuccess> =>
  axios.put(`/sales-crm/my-offers/${offerId}/accept`, payload ?? {});

export const usePutSalesCrmMyOfferAccept = (
  offerId: string | number,
  options?: UseMutationOptions<ICommandResponseSuccess, IError, IPutSalesCrmMyOfferAcceptPayload | void>
) =>
  useMutation(
    (payload?: IPutSalesCrmMyOfferAcceptPayload) => putSalesCrmMyOfferAccept(offerId, payload),
    options
  );
